import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
// import CustomTable from "../../../Components/Table";
import { useEffect, useState } from "react";
import { mcaI20Logo, mcaLogo, teamDetailsHeaderBg } from "../../../Assets";
import { getPlayersDetails } from "../../../Utils/apiService";
import { useAuthStore } from "../../../store";
import PlayerSection from "./components/PlayerSection";

const IconPlayers = () => {
  const [playerDetails, setPlayerDetails] = useState<any>();

  const { teamDetailsTrigger } = useAuthStore();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [playerRes] = await Promise.all([getPlayersDetails()]);

        if (playerRes?.data?.success) {
          const data = playerRes.data?.data;
          const filteredData = data.filter(
            (player: any) =>
              player.recentCompetetionLevel === "Indian senior team"
          );
          setPlayerDetails(filteredData);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, [teamDetailsTrigger]);

  const renderInitialLogo = () => (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        background: "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "4vw",
          // position: "absolute",
          marginBottom: "80px",
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        <img
          src={mcaI20Logo}
          style={{ height: "13vw", width: "auto" }}
          alt=""
        />
        <Typography sx={{ fontSize: "3.3vw", color: "#fff", fontWeight: 800 }}>
          T20 Mumbai league - 2025
        </Typography>
      </Box>
    </Box>
  );

  if (!playerDetails) {
    return renderInitialLogo();
  }

  return (
    <Box
      sx={{
        height: "100%",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "center",
        gap:"5vw"
      }}
    >
      <Box
        sx={{
          // padding: ".3vw 2vw",
          // borderRadius: ".4vw",
          // background:
          //   "linear-gradient(90deg, rgba(146, 208, 119, 0.48) 0%, rgba(89, 183, 48, 0.00) 100%)",
          // backgroundImage: `url(${playerDetailsBg})`,
          display: "flex",
          alignItems: "center",
          gap: "20px",
          position: "relative",
          width: "100%",
        }}
      >
        <img
          src={teamDetailsHeaderBg}
          style={{ width: "100%", height: "100%", position: "absolute" }}
          alt="player team logo"
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            paddingX: "90px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              position: "relative",
            }}
          >
            <img
              src={mcaLogo}
              style={{ height: "5vw", width: "auto" }}
              alt="logo"
            />
          </Box>
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                padding: "2.2vw 2vw",
                position: "relative",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  backgroundImage:
                    "radial-gradient(61.24% 43.3% at 50% 50%, #FFF200 0%, #FFF200 26%, #FBB040 97%)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "1.4vw",
                  textAlign: "center",
                }}
              >
                ICON PLAYERS OF THE SEASON
              </Typography>
            </Box>
            <Box sx={{ position: "relative" }}></Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              position: "relative",
            }}
          >
            <img
              src={mcaI20Logo}
              style={{ height: "6vw", width: "auto" }}
              alt="logo"
            />
          </Box>
        </Box>
      </Box>
      <PlayerSection teamDetails={playerDetails} />
      <Typography variant="h1" color="white"></Typography>
    </Box>
  );
};

export default IconPlayers;
